import { baseColors } from './baseColors'
import { baseTheme } from './baseTheme'
import { ThemeType } from './theme.types'

export const intervaleTheme: ThemeType = {
  ...baseTheme,
  colors: {
    text: {
      primary: baseColors.black_700,
      secondary: baseColors.gray_500,
      tertiary: baseColors.neutral_400,
      inverted: baseColors.neutral_50,
      positive: baseColors.green_500,
      negative: baseColors.red_400,
      primaryLink: '#0068cd',
      secondaryLink: baseColors.neutral_400,
      visitedLink: baseColors.violet_500,
      accent: '#0068cd',
      visitedSecondaryLink: baseColors.neutral_500,
      warning: baseColors.amber_300,
      disabled: baseColors.neutral_300,
    },

    background: {
      primary: baseColors.neutral_50,
      modal: baseColors.neutral_50,
      secondary: baseColors.gray_100,
      inverted: baseColors.black_800,
      hover: baseColors.gray_400_10,
      header: baseColors.neutral_50,
      disabled: baseColors.black_1000_5,
      elevated: baseColors.neutral_50,
      warning: baseColors.amber_300_30,
      positive: baseColors.green_500,
      accent: '#0068cd',
      accent_30: '#0068cd4D',
      tertiary: baseColors.neutral_200,
      gradientAccent: '#0068cd',
      gradientSecondary: '#011528',
    },

    icon: {
      primary: baseColors.black_700,
      secondary: baseColors.gray_500,
      tertiary: baseColors.neutral_400,
      inverted: baseColors.neutral_50,
      accent: '#0068cd',
      positive: baseColors.green_500,
      negative: baseColors.red_400,
      warning: baseColors.amber_300,
      disabled: baseColors.neutral_300,
    },

    badge: {
      sale: baseColors.lime_400,
      new: '#0068cd',
      popular: baseColors.orange_500,
      waiting: baseColors.neutral_100,
      official: baseColors.sky_500,
      official_20: baseColors.sky_500_30,
      sale_20: baseColors.lime_400_30,
      new_20: '#0068cd4D',
      popular_20: baseColors.orange_500_30,
      negative: baseColors.red_500,
      negative_20: baseColors.red_500_20,
      positive: baseColors.green_500,
      positive_20: baseColors.green_500_20,
      warning: baseColors.amber_300,
      warning_20: baseColors.amber_300_20,
    },

    stroke: {
      default: baseColors.neutral_300,
      hover: baseColors.neutral_400,
      active: '#0068cd',
      error: baseColors.red_400,
      alternativeActive: baseColors.neutral_800,
      positive: baseColors.green_300,
    },

    overlay: {
      primary: baseColors.neutral_400_90,
      primary_65: baseColors.neutral_100_65,
    },

    toast: {
      success: {
        background: baseColors.green_500,
        icon: baseColors.green_700,
      },
      error: {
        background: baseColors.red_500,
        icon: baseColors.red_700,
      },
      warning: {
        background: baseColors.amber_500,
        icon: baseColors.amber_700,
      },
      info: {
        background: baseColors.blue_500,
        icon: baseColors.blue_700,
      },
    },

    constant: {
      white: baseColors.neutral_50,
      white_5: baseColors.neutral_100_5,
      white_10: baseColors.neutral_100_10,
      white_65: baseColors.neutral_100_65,
      black: baseColors.black_800,
      gray: baseColors.neutral_500,
    },
  },
}
